// extracted by mini-css-extract-plugin
module.exports = {"splashScreenWrapper":"KanBo_splashScreenWrapper__KCVbv","splashScreen":"KanBo_splashScreen__31FiH","logo":"KanBo_logo__2O7Fy"};